<template>
  <div
    v-if="isGetConfig"
    class="error"
    :style="errorBackground"
  >
    <b-container class="board">
      <error-404 :config-data="configData" />
    </b-container>

    <template-footer
      :config-data="configData.style.footer"
      :ad-data="adConfig"
    />
    <copy-right v-if="isGetConfig && footerDisplay" />
  </div>
</template>

<script>
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BContainer,
} from 'bootstrap-vue'
import Error404 from './Error404.vue'
import TemplateFooter from '../component/TemplateFooter.vue'
import CopyRight from '../component/CopyRightFooter.vue'

import store from '@/store'
import useStoreModule from './useStoreModule'

export default {
  components: {
    BContainer,
    Error404,
    TemplateFooter,
    CopyRight,
  },
  data() {
    return {
      errorBackground: null,
    }
  },
  computed: {
    supportWebp() {
      return this.$store.state.app.supportWebp
    },
  },
  watch: {
    isGetConfig(value) {
      if (value) {
        this.handleResize()
      }
    },
  },
  created() {
    // 在组件创建时添加窗口大小变化的事件监听器
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 在组件销毁之前移除事件监听器，以防止内存泄漏
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    webpImage(src) {
      if (!src) return ''
      const webpSrc = src.replace(/\.[^.]+$/, '.webp')
      // const webpSrc = `${src.split('.')[0]}.webp`
      return webpSrc
    },
    handleResize() {
      const windowWidth = window.innerWidth
      this.errorBackground = { backgroundImage: '' }
      if (windowWidth > 991) {
        if (this.configData.style.base.background.image) {
          this.errorBackground.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(this.configData.style.base.background.image) : this.configData.style.base.background.image}`
        }
      } else {
        const backgroundImage = this.configData.style.base.backgroundsm.image ? this.configData.style.base.backgroundsm.image : this.configData.style.base.background.image
        if (backgroundImage) {
          this.errorBackground.backgroundImage = `url(${this.baseUrl}${this.supportWebp ? this.webpImage(backgroundImage) : backgroundImage}`
        }
      }
    },
  },
  setup() {
    // 模組註冊
    const HOME_ADMIN_STORE_MODULE_NAME = 'error'

    if (!store.hasModule(HOME_ADMIN_STORE_MODULE_NAME)) store.registerModule(HOME_ADMIN_STORE_MODULE_NAME, useStoreModule)

    onUnmounted(() => {
      if (store.hasModule(HOME_ADMIN_STORE_MODULE_NAME)) store.unregisterModule(HOME_ADMIN_STORE_MODULE_NAME)
    })

    const isGetConfig = ref(false)
    const adConfig = ref(null)
    const configData = ref(null)
    const baseUrl = ref('')
    const footerDisplay = ref(true)

    const getAdConfig = () => {
      store.dispatch('error/getAdConfig')
        .then(localResponse => {
          adConfig.value = localResponse.data
        })
    }

    const getLocalConfig = () => {
      store.dispatch('error/getLocalConfig')
        .then(localResponse => {
          configData.value = localResponse.data
          isGetConfig.value = true
        })
    }
    const getErrorConfig = () => {
      store.dispatch('error/getErrorConfig')
        .then(response => {
          configData.value = response.data.data
          baseUrl.value = response.data.data.base_url
          if (response.data.data.support_url) store.dispatch('api/loadTawkToScript', response.data.data.support_url)
          if (response.data.data.footer_display !== undefined && response.data.data.footer_display === false) footerDisplay.value = false
          store.commit('api/UPDATE_BASE_URL', baseUrl.value)
          if (configData.value && configData.value.style) isGetConfig.value = true
          else getLocalConfig()
        })
        .catch(() => {
          getLocalConfig()
        })
    }
    getAdConfig()
    getErrorConfig()
    // getLocalConfig()
    return {
      baseUrl,
      footerDisplay,
      adConfig,
      configData,
      isGetConfig,
    }
  },
}
</script>

<style lang="scss" scoped>
$background-color: var(--background-color);
.error {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  position: relative;
  background-color: transparent;
  @media screen and (max-width: 575px) {
    background-size:auto;
  }
}

.top {
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  margin-top: -100px;
  width: 100%;
  transform: translateX(-50%);
  @media screen and (max-width: 767px) {
    display: none;
  }
}
.bottom {
  position: relative;
  z-index: 1;
  bottom: 0;
  left: 50%;
  margin-top: -100px;
  width: 100%;
  transform: translateX(-50%);
  @media screen and (max-width: 767px) {
    display: none;
  }
}
.board {
  position: relative;
  z-index: 0;
  height: 100vh;
  padding: 0px;
}
</style>
